// Vendor imports
const { createSelector } = require('reselect')
// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')

const containerState = state => state.contentAddModal

// Article selectors

const isVisible = createSelector(
  containerState,
  s => s ? s.isVisible : false
)

const article = createSelector(
  containerState,
  s => s ? s.article : undefined
)

const urlId = createSelector(
  article,
  a => a ? a['url_id'] : undefined
)

const url = createSelector(
  containerState,
  (containerState) => {
    return containerState.url
  }
)

const isArticleLoaded = createSelector(
  containerState,
  s => s ? s.articleState === FetchStateEnum.LOADED : false
)

const isArticleLoading = createSelector(
  containerState,
  s => s ? s.articleState !== FetchStateEnum.LOADED && s.articleState !== FetchStateEnum.FAILED && s.url !== '' && !s.isUrlInvalid : false
)

const isArticleFailed = createSelector(
  containerState,
  s => s ? s.articleState === FetchStateEnum.FAILED : false
)

const isUrlInvalid = createSelector(
  containerState,
  s => s ? s.isUrlInvalid : false
)

const isSubmitPending = createSelector(
  containerState,
  s => s ? s.isSubmitPending : false
)

const errorMessage = createSelector(
  [
    containerState,
    isArticleFailed
  ],
  (containerState, isArticleFailed) => {
    if (isArticleFailed) {
      return 'Sorry, we couldn’t gather information from this website.'
    }
    if (containerState.isUrlInvalid) {
      return 'Sorry, that looks like an invalid URL.'
    }
    return
  }
)

// Extensions selectors

const isMobile = createSelector(
  [
    state => state.env.browser
  ],
  (browser) => {
    return Boolean(
      browser.get('isMobile')
    )
  }
)

module.exports = {
  article,
  containerState,
  errorMessage,
  isArticleLoaded,
  isArticleLoading,
  isArticleFailed,
  isMobile,
  isSubmitPending,
  isUrlInvalid,
  isVisible,
  url,
  urlId
}
